module.exports = __webpack_public_path__ + "static/media/sombrero (3).68311189.png";